import React from "react";
import './index.css'
import Logo from '../../../../assets/img/icon.png'
import { Link, useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
const Header = ()=>{
    const {pathname} = useLocation();
    const selectedTournament = useSelector(state => state?.tournaments?.selectedTournament)
    console.log('selectedTournament', selectedTournament)
    

    return(
        <div className="talacha-header">
            <div className="talacha-header-logo">
                <img src={Logo} />
                <p>Talacha App</p>
            </div>
            <div className="talacha-header-nodes">
                <p className={pathname === '/' ? 'active' : ''}>
                    <Link to={'/'}>
                    Partidos
                    </Link> </p>
                    {
                        selectedTournament?.esPorGrupos && (
                            <p className={pathname.includes('table') ? 'active' : ''}>
                            <Link to={'/table'}>
                            Grupos
                            </Link></p>
                        )
                    }

                    <p className={pathname.includes('tablaGeneral') ? 'active' : ''}>
                    <Link to={'/tablaGeneral'}>
                    Tabla general
                    </Link></p>
                    {selectedTournament?.esActivoTablaGoleo && (
                                            <p className={pathname.includes('tablaGoleo') ? 'active' : ''}>
                                            <Link to={'/tablaGoleo'}>
                                            Goleadores
                                            </Link></p>

                    )}
                                        {selectedTournament?.esActivoCampeones && (
                                            <p className={pathname.includes('champions') ? 'active' : ''}>
                                            <Link to={`/champions/${selectedTournament?._id}`}>
                                            Campeones
                                            </Link></p>

                    )}
                    {
                        selectedTournament?.esActivoTablaAsistencias && (
                                              <p className={pathname.includes('tablaAsistencia') ? 'active' : ''}>
                                            <Link to={'/tablaAsistencia'}>
                                            Asistencias
                                            </Link></p>

                        )
                    }

                    <div className="custom-link-pattern" >
                        <a target="_blank" href="https://www.facebook.com/share/1CbGyKUyMs/?mibextid=wwXIfr">
                        <img src="https://i.ibb.co/V0dFkZ5T/baea3044-5f31-440a-b8bb-0ce70290309a-removebg-preview.png" />
                        </a>
                        Trofeos JR

                    </div>


                    {/* <p className={pathname.includes('visorias') ? 'active' : ''}>
                    <Link to={'/visorias'}>
                    Visorias
                    </Link></p> */}

            </div>
            <div></div>

        </div>
    )
}

export default Header;
